import {Component, EventEmitter, Input, Output} from '@angular/core';
import {User} from '../models/user';

@Component({
  selector: 'user-editor-header',
  template: `
    <div class="row">
      <div class="col-md-7">
        <label>
          <span *ngIf="!isNewUser">Edit</span>
          <span *ngIf="isNewUser">Create New User</span>
        </label>
      </div>
      <div class="col-md-5 text-right">
        
      </div>
    </div>
  `
})
export class UserEditorHeaderComponent {
  @Input() isNewUser: boolean;
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/user-editor-header.ts